import restCrudActions from '../../../np-crud/store/restCrudActions';
import config from "../../../../config/config";
import { getAxiosInstance } from "../../../np-rest/rest";
import * as actionTypes from "../store/actionTypes";
import { snackActions } from '../../../sc-utilities/SnackBar';
// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: '/billing/delivery-note',
    pluginName: 'BILLING',
    entityName: 'DELIVERY_NOTE',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true
});

export const createDeliveryNote = deliveryNoteParams => {
    return async dispatch => {
        await crudActions.create(dispatch, deliveryNoteParams);
    };
};

export const chargingDeliveryNoteStart = () => {
    return {
        type: actionTypes.CHARGING_DELIVERY_NOTE_START
    };
};
export const chargingDeliveryNoteSuccess = charged => {
    return {
        type: actionTypes.CHARGING_DELIVERY_NOTE_SUCCESS,
        charged: charged
    };
};
export const chargingDeliveryNoteFail = () => {
    return {
        type: actionTypes.CHARGING_DELIVERY_NOTE_FAIL
    };
};

export const fetchDeliveryNotesInit = () => {
    return crudActions.fetchInit();
};
export const fetchDeliveryNotesStart = () => {
    return crudActions.fetchStart();
};
export const fetchDeliveryNotesSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchDeliveryNotesFail = () => {
    return crudActions.fetchFail();
};

export const fetchDeliveryNotesCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchDeliveryNotesStart());
        try {
            let countRes = await rest.post("/delivery-note/count", filterData, { cancelToken: options?.countSource?.token });
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            if (countRes.data && countRes.data.succeeded) {
                return { data: countRes.data.result.data }
            }

            dispatch(fetchDeliveryNotesFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch delivery notes."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchDeliveryNotesFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch delivery notes."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};

export const fetchDeliveryNotes = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchDeliveryNotesStart());
        try {
            let listRes = await rest.post("/delivery-note/list", filterData, { cancelToken: options?.listSource?.token });
            if (listRes && listRes.canceled) {
                return { data: [], count: 0, canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchDeliveryNotesSuccess());
                return { data: listRes.data.result.data };
            }
            dispatch(fetchDeliveryNotesFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchDeliveryNotesFail());

            return { data: [] };
        }
    }
};



export const billDeliveryNote = (DeliveryNote, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(chargingDeliveryNoteStart());
            let res = await rest.post('/billing/delivery-note/charge', DeliveryNote, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return { data: [], count: 0, canceled: true };
            }
            if (res.data && res.data.succeeded) {
                dispatch(chargingDeliveryNoteSuccess(res.data.result.data));
                return res.data.result.data;
            }
            dispatch(chargingDeliveryNoteFail());
            return {};
        } catch (error) {
            dispatch(chargingDeliveryNoteFail());
            return {};
        }
    };
};

export const downloadPdf = id => {
    let token = localStorage.getItem('SESSION');

    return async dispatch => {
        return fetch(`${config.backend_domain}:${config.backend_port}/billing/delivery-note/download?DeliveryNoteID=${id}&Token=${token}`, {
            method: "GET",
        }).then(response => {
            if (response.status === 200) {
                return response.blob();
            }
            return null;
        });
    }
};